import { I18n, createI18n } from 'vue-i18n'

import messages from '@/lang'
import { languages } from '@/constants/languages'
import { IApp } from '@/types/app'

export const i18n = createI18n({
  locale: languages[0].locale,
  legacy: false,
  messages,
  globalInjection: true
})

const initI18n = (app: IApp): I18n => {
  const localeMessage: Record<string, Record<string, string>> = {
    ...(messages as unknown as Record<string, Record<string, string>>)
  }

  const userPreferences = app.$cookies.get('userPreferences') ?? {}
  const language = userPreferences.language ?? languages[0]

  return createI18n({
    locale: language.locale, // set fallback locale
    legacy: false, // you must set `false`, to use Compostion API
    messages: localeMessage, // set locale messages
    globalInjection: true
  })
}

export default initI18n
